<template>
  <div class="kpi-order-cancel-page">
    <div class="btn bottom-line">
      <van-button type="info" @click="scaneCode">扫一扫</van-button>
    </div>

    <div class="tip">核销记录</div>

    <van-tabs
      v-model="activeName"
      title-active-color="#3283fa"
      color="#3283fa"
      :sticky="true"
      :swipe-threshold="4"
      @click="changeType"
    >
      <van-tab
        class="list"
        :name="type.title"
        v-for="(type, index) in types"
        :key="index"
        :title="type.title"
      >
        <van-list
          v-if="activeName === type.title&&type.list&&type.list.length>0"
          :loading="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load
        >
          <!-- 核销列表 -->
          <div class="order bottom-line" v-for="(item, i) in type.list" :key="i">
            <div class="content" v-if="activeName=='集赞礼品'">
              <div>客户昵称：{{item.nickName}}</div>
              <div>客户姓名：{{item.userName}}</div>
              <div>客户手机号：{{item.mobile}}</div>
              <div>核销员：{{item.kpiUserName}}</div>
              <div>核销时间：{{item.finishTime}}</div>
            </div>
            <div class="content" v-if="activeName=='代金券'">
              <div>优惠券所属品牌：{{item.brandName}}</div>
              <div>客户姓名：{{item.nickName}}</div>
              <div>客户手机号：{{item.mobile}}</div>
              <div>核销员：{{item.kpiUserName}}</div>
              <div>所属门店：{{item.shopName||'-'}}</div>
              <div>转单金额：{{item.changeAmount||'-'}}</div>
              <div>核销时间：{{item.finishTime}}</div>
            </div>
            <div class="content" v-if="activeName=='秒杀订单'">
              <div>秒杀商品名称：{{item.productName}}</div>
              <div>秒杀商品所属品牌：{{item.brandName||'-'}}</div>
              <div>订单金额：{{item.payAmount}}</div>
              <div>客户姓名：{{item.nickName}}</div>
              <div>客户手机号：{{item.mobile}}</div>
              <div>核销员：{{item.kpiUserName}}</div>
              <div>核销员所属品牌：{{item.kpiBrandName||'-'}}</div>
              <div>核销员所属门店：{{item.shopName||'-'}}</div>
              <div>核销时间：{{item.finishTime}}</div>
            </div>
            <div class="content" v-if="activeName=='直播订单'">
              <div>直播商品名称：{{item.productName}}</div>
              <div>直播商品所属品牌：{{item.brandName||'-'}}</div>
              <div>订单ID：{{item.tradeNo}}</div>
              <div>订单金额：{{item.payAmount}}</div>
              <div>客户姓名：{{item.nickName}}</div>
              <div>客户手机号：{{item.mobile}}</div>
              <div>核销员：{{item.kpiUserName}}</div>
              <div>核销员所属品牌：{{item.kpiBrandName||'-'}}</div>
              <div>核销员所属门店：{{item.shopName||'-'}}</div>
              <div>转单金额：{{item.changeAmount||'-'}}</div>
              <div>核销时间：{{item.finishTime}}</div>
            </div>
          </div>
          <!-- 空数据 -->
        </van-list>
        <div v-else class="empty-data">
          <span>没有相关记录</span>
        </div>
      </van-tab>
    </van-tabs>

    <div class="home-over-btn">
      <router-link :to="{ name: 'kpi.home', query: { user_id: user_id, kpi_uid: kpi_userid,act_id: activity_id}}">
        <img src="https://j.weizan.cn/youxiang/images/home-over.png"/>
        首页
      </router-link>
    </div>
  </div>
</template>

<script>
// import { getCardRecord } from "@/utils/kpiRequest.js";
export default {
  created() {
    this.$initWXSDK({}, () => {
      wx.hideAllNonBaseMenuItem();
    });
  },
  mounted() {
    this.getCollectRecord();
    this.activityName = localStorage.getItem("kpiRealName") || "";
    // this.getCardRecord();
    // this.getSeckillRecord();
    // this.getLiveRecord();
  },

  data() {
    return {
      activity_id: this.$route.query.act_id || localStorage.getItem("act_id"),
      user_id: localStorage.getItem("user_id"),
      kpi_userid: localStorage.getItem("kpi_user_id") || null,
      activeName: 0,
      types: [
        { title: "集赞礼品", list: [] },
        { title: "代金券", list: [] },
        { title: "秒杀订单", list: [] },
        { title: "直播订单", list: [] },
      ],
      page: 1,
      loading: false,
      finished: true,
      radio: "",
      user: null,
      kpi_user: null,
      RecordList: [],
    };
  },
  methods: {
    // 切换核销记录
    changeType(val) {
      console.log(val);
      console.log(this.activeName);
      if (this.activeName == "集赞礼品") {
        this.types[0].list = [];
        this.getCollectRecord();
      } else if (this.activeName == "代金券") {
        this.types[1].list = [];
        this.getCardRecord();
      } else if (this.activeName == "秒杀订单") {
        this.types[2].list = [];
        this.getSeckillRecord();
      } else if (this.activeName == "直播订单") {
        this.types[3].list = [];
        this.getLiveRecord();
      }
    },
    // 获取核销记录
    async getCollectRecord() {
      var act = {
        actId: Number(localStorage.getItem("act_id")),
        page: 1,
        size: 1000,
      };
      let res = await this.$http.post("/v1/kpiuser/collect_record", act);
      console.log(res);
      if (res.data && res.data.list.length > 0) {
        this.types[0].list = res.data.list;
      }
    },
    async getCardRecord() {
      var act = {
        actId: Number(localStorage.getItem("act_id")),
        page: 1,
        size: 1000,
      };
      let res = await this.$http.post("/v1/kpiuser/card_record", act);
      console.log(res);
      if (res.data && res.data.list.length > 0) {
        this.types[1].list = res.data.list;
      }
    },
    async getSeckillRecord() {
      var act = {
        actId: Number(localStorage.getItem("act_id")),
        page: 1,
        size: 1000,
        type: "seckill",
      };
      let res = await this.$http.post("/v1/kpiuser/order_record", act);
      console.log(res);
      if (res.data && res.data.list.length > 0) {
        this.types[2].list = res.data.list;
      }
    },
    async getLiveRecord() {
      var act = {
        actId: Number(localStorage.getItem("act_id")),
        page: 1,
        size: 1000,
        type: "live",
      };
      let res = await this.$http.post("/v1/kpiuser/order_record", act);
      console.log(res);
      if (res.data && res.data.list.length > 0) {
        this.types[3].list = res.data.list;
      }
    },
    scaneCode() {
      console.log("1");
      wx.scanQRCode({
        needResult: 0, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ["qrCode", "barCode"], // 可以指定扫二维码还是一维码，默认二者都有
      });
    },
  },
};
</script>

<style lang="less" scoped>
.van-tab__text--ellipsis {
  line-height: 24px;
}
.empty-data {
  padding: 20px;
  overflow: hidden;
  text-align: center;
  color: #666;
  font-size: 14px;
  display: flex;
  align-items: center;

  span {
    padding: 0 20px;
  }
}
.empty-data:before,
.empty-data:after {
  content: "";
  display: inline-block;
  height: 0;
  border-bottom: #ddd solid 1px;
  flex: 1;
  position: relative;
}
.kpi-order-cancel-page {
  .btn {
    width: 100%;
    text-align: center;
    background-color: #ffffff;
    line-height: 110px;
    button {
      width: 90%;
    }
  }

  .tip {
    padding: 10px 15px;
    background-color: #ddd;
  }

  .order {
    /*核销记录*/
    background-color: #ffffff;
    .title {
      padding: 10px 15px;
      font-weight: bold;
    }
    div:first-child::after {
      left: 15px;
    }
    .content {
      padding: 10px 15px;
      color: #666666;
      font-size: 13px;
      line-height: 23px;
    }
  }
}
</style>